import { Box, Paper } from "@mui/material"
import { appGifs } from "../../assets"

const LoadingContainer = ({ isLoading, children }) => {
    return (
        <Paper sx={{
            height: "calc(100vh - 130px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <Box
                component="img"
                src={appGifs.blueLoading}
                alt="loading"
                width={"200px"}
                height={"200px"}
                style={{ margin: "auto", display: "block" }}
            />
        </Paper>
    )
}

export default LoadingContainer;